import { rootApi } from "../../api/rootApi";

export const notificationTemplateApiAdmin = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllNotificationTemplatesAdmin: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/notification-v2`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: "0", // Admin uses slug 0
                    },
                    body: params.body,
                };
            },
        }),
        addNotificationTemplateAdmin: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/notification-v2/add`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.body.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        updateNotificationTemplateAdmin: builder.mutation({
            query: (params) => {
                return {
                    method: "PUT",
                    url: `/tenant/notification-v2/${params.id}`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.body.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        updateNotificationTemplateStatusAdmin: builder.mutation({
            query: (params) => {
                return {
                    method: "PUT",
                    url: `/tenant/notification-v2/status/${params.id}`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params?.body?.tenant_id || 0,
                    },
                    body: {
                        status: params.status,
                    },
                };
            },
        }),
    }),
});

export const {
    useGetAllNotificationTemplatesAdminMutation,
    useAddNotificationTemplateAdminMutation,
    useUpdateNotificationTemplateAdminMutation,
    useUpdateNotificationTemplateStatusAdminMutation,
} = notificationTemplateApiAdmin;
